import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;
function ItemInventario(props) {
    const { regional, idSucursal, item, anio, mes, ventaInfo, productosFiltro, setLoading,idProducto } = props;
    const [productos, setProductos] = useState([]);
    const [productosd, setProductosd] = useState([]);
    const [totales, setTotales] = useState([]);
    function obtenerInformacion() {
        console.log("obteniendo informacion")
        fetch(`${server}/reporte/getHistoricoVentas`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: regional, idSucursal, mes: item.id, anio: anio[0], aniod: anio[1], ids: productosFiltro
            })
        })
            .then(res => res.json())
            .then(data => {
                setLoading(false);
                if (data.ok) {
                    console.log(data.ok);
                    setProductos(data.ok[0]);
                    setProductosd(data.ok[1]);
                    var aux = data.ok[0].reduce(function (acumulador, objeto) {
                        return acumulador + objeto.CANTIDAD;
                    }, 0);
                    var aux1 = data.ok[1].reduce(function (acumulador, objeto) {
                        return acumulador + objeto.CANTIDAD;
                    }, 0);
                    setTotales([aux, aux1]);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err));
    }
    useEffect(() => {
        if (mes != -1) {
            obtenerInformacion()
        } else {
            setProductos(ventaInfo[0]);
            setProductosd(ventaInfo[1]);
            var aux = ventaInfo[0].reduce(function (acumulador, objeto) {
                return acumulador + objeto.CANTIDAD;
            }, 0);
            var aux1 = ventaInfo[1].reduce(function (acumulador, objeto) {
                return acumulador + objeto.CANTIDAD;
            }, 0);
            setTotales([aux, aux1]);
        }
    }, [])
    return (
        <>
            {productos.length !== 0 &&
                productos.map((valor, index) => {
                    return (
                        <tr key={index} >
                            {index == 0 && <th className={`${index == 0 ? 'bg-secondary' : ''}`}>{item.nombre}</th>}
                            {index !== 0 && <th></th>}
                            <td className={`${index == 0 ? 'bg-secondary' : ''}`}>{valor.DESCRIPCION}</td>
                            <td className={`${index == 0 ? 'bg-secondary' : ''}`}>{idProducto == 1 ? parseInt(valor.CANTIDAD / 100) + ' - ' + parseInt(valor.CANTIDAD % 100) : valor.CANTIDAD}</td>
                            <td className={`${index == 0 ? 'bg-secondary' : ''}`}>{productosd.length !== 0 ? (idProducto == 1 ? parseInt(productosd[index].CANTIDAD / 100) + ' - ' + parseInt(productosd[index].CANTIDAD % 100) : productosd[index].CANTIDAD) : '-'}</td>
                            <td className={`${index == 0 ? 'bg-secondary' : ''}`}>{idProducto == 1 ? 'Bandejas' : valor.UNIDAD}</td>
                        </tr>
                    )
                })
            }
            {idProducto==1&&
            <tr>
                <th></th>
                <td className='bg-gradient'>Total</td>
                <td className='bg-gradient'>{parseInt(totales[0] / 100) + ' - ' + parseInt(totales[0] % 100)}</td>
                <td className='bg-gradient'>{parseInt(totales[1] / 100) + ' - ' + parseInt(totales[1] % 100)}</td>
                <td className='bg-gradient'></td>
            </tr>}
        </>
    )
}

export default ItemInventario